<template>
  <div class="pageIndexPage"
    @touchstart="touchEvent" 
    @touchmove="touchEvent" 
    @touchend="touchEvent" 
    @scroll="touchEvent">  
    <mu-appbar class="XR-index-head" ref="XRIndexHead">
      <mu-raised-button class="demo-raised-button"  slot="left" :label="addressCache" labelPosition="before" icon=":fa fa-angle-down" primary @click="selectArea" />
      <img class="xrglogo" :src="siteInfo.Logo" v-if="!salesmanShopName"/>
      <div class="salesmanShopName" v-if="salesmanShopName">
        {{salesmanShopName.length>8?salesmanShopName.substr(0,8)+'...':salesmanShopName}}
      </div>
      <mu-icon-button to="/retail/search" icon=":fa fa-mysearch3" slot="right"/>
      <mu-icon-menu   icon=":fa fa-mymore" slot="right">
        <mu-menu-item to="/usercenter/messageTypeList" title="消息中心"/>
        <mu-menu-item to="/usercenter/index" title="个人中心"/>
        <mu-menu-item to="/retail/cart" title="购物车"/>
      </mu-icon-menu>
    </mu-appbar>
    <div ref="banner" class="bannerList">
      <XR-swiper :showIndic="true" ref="swiper" v-if="templeteData.Head && templeteData.Head.Banners.length>0" :interval="templeteData.Head.ScrollSpeed">
        <XR-slide v-for="(img,index) in templeteData.Head.Banners" :key=index>
          <a :href="img.Link"><img :src="img.Img" /></a>
        </XR-slide>
      </XR-swiper>
      <div class="cicle_top" v-if="salesmanShopName">
        <div class="cicle" > 
          {{salesmanShopName.length>8?salesmanShopName.substr(0,4) +'...'+'的微商城':salesmanShopName}}
        </div>
      </div>
    </div>
    
    <!-- <template v-if="projectName == 'xurigo'">
      <div class="cicle_top"
       :style="{top:bannerHeight+'px'}"
       v-if="templeteData.Head && templeteData.Head.Banners.length>0"
       :interval="templeteData.Head.ScrollSpeed">
        <div class="cicle" > 
          </div>
      </div>
    </template> -->
    <div class="nav">
      <ul>
        <li v-for="navItem in bottomNavList" :key="navItem.Id"> 
          <template v-if="navItem.IconType==1">   
            <template v-if="!navItem.Url">
              <p class="link-btn" @click="toBeOnline">
                <mu-icon :value="':'+navItem.Icon"></mu-icon><b>{{navItem.Name}}</b>
              </p>
            </template> 
            <template v-if="navItem.Url">
              <router-link class="link-btn" :to="navItem.Url" v-if="navItem.IconType==1">
                <mu-icon :value="':'+navItem.Icon"></mu-icon><b>{{navItem.Name}}</b>
              </router-link>
            </template>            
          </template>
          <template v-if="navItem.IconType==2">    
            <template v-if="!navItem.Url">
              <p class="link-btn" @click="toBeOnline">
                <img :src="navItem.Icon"><b>{{navItem.Name}}</b>
              </p>  
            </template>        
            <template v-if="navItem.Url">   
              <router-link class="link-btn" :to="navItem.Url">
                <img :src="navItem.Icon"><b>{{navItem.Name}}</b>
              </router-link>  
            </template>     
          </template>
        </li>
      </ul>		
    </div>

    <div id="gonggao" :style="{marginTop: gonggaoTop +'px'}">
      <div class="gg-title">
        <img src="static/toutiao.gif"/>
		<!--
        <img src="static/index/top_1.png" style="transform: rotateY(0);z-index: 2;" />
        <img src="static/index/top_1.png" style="transform: rotateY(-180deg)"/>
		-->
      </div>
      <div class="gg-list">
        <img src="https://frontEnd.xurigo.com/icon/new.gif" class="new">
        
        <ul :class="{marquee_top:animate}">
          <template v-for="notice in noticeList">
            <router-link :to="getNoticeUrl(notice.Type,notice.Id)" :key="notice.Id">
              <li>
                <p class="title">{{notice.Title }}</p>
                <p class="content"><span v-html="HTMLDecode(notice.Title)"></span></p>
              </li>
            </router-link>
          </template>
        </ul>
      </div>
      <div class="removeHtmlDiv" style="display:none;"></div>
    </div>

    <!-- <div class="coupon" style="width: 100%;margin: 10px 0;">
      <img style="width: 100%;display: block;" src="../../static/coupon/13.png" alt="">
    </div> -->
    
    <template v-for="mItem in templeteData.Modules">
      <XR-mobile-groupShop ref="ModuleGroupShop" v-if="mItem.CtrlName=='pintuan'"></XR-mobile-groupShop>

      <XR-mobile-buynow v-if="mItem.CtrlName=='miaosha'" src="/static/index/1.gif"></XR-mobile-buynow>

      <XR-mobile-todaynew1 v-if="mItem.CtrlName=='today1'"></XR-mobile-todaynew1>

      <XR-mobile-todaynew2 v-if="mItem.CtrlName=='today2'"></XR-mobile-todaynew2>

      <XR-mobile-ad1 v-if="mItem.CtrlName=='ad1'" :guid="mItem.Guid" :configData="templeteData"></XR-mobile-ad1>

      <XR-mobile-ad2 v-if="mItem.CtrlName=='ad2'" :guid="mItem.Guid" :configData="templeteData"></XR-mobile-ad2>
	  
	  <XR-mobile-ad3 v-if="mItem.CtrlName=='ad3'" :guid="mItem.Guid" :configData="templeteData"></XR-mobile-ad3>
	  
	  <XR-mobile-ad4 v-if="mItem.CtrlName=='ad4'" :guid="mItem.Guid" :configData="templeteData"></XR-mobile-ad4>

      <XR-mobile-adImg1 v-if="mItem.CtrlName=='adImg1'" :guid="mItem.Guid" :configData="templeteData"></XR-mobile-adImg1>

      <template v-if="mItem.CtrlName=='discount1'">        
        <XR-mobile-youpin1 ref="ModuleYouPin" ></XR-mobile-youpin1>
      </template>
      <template v-if="mItem.CtrlName=='discount2'">     
        <XR-mobile-youpin2  ref="ModuleYouPin" ></XR-mobile-youpin2>
      </template>

    </template>
     
    <div style="margin-bottom: 56px;">
      <div class="bottom-line">
          <p class="lineOne"></p>
          <img class="bottomImg" src=" ../static/theend.png" alt="">
          <p class="lineTwo"></p>
      </div> 
      <div class="foot_inf">
            <h3>和谐共赢·诚信天下</h3>
        <p>
          Copyright © 2012-{{nowYear}} {{siteInfo.SiteName}}
        </p>
        <p>
          和诚旭日电子商务湖北有限公司 版权所有 <a href="http://www.beian.miit.gov.cn" target="_blank" class="beianLink">{{siteInfo.BeiAn}}</a>
        </p>
      </div>
    </div>

    <XR-toast ref="XRtoast"></XR-toast>
    <XR-signin ref="XRsigin"></XR-signin>
    
    <XR-bottom ref="XRbottom"></XR-bottom>

    
    <mu-dialog :open="dialog" title="选择地区">
        需要知道您的位置才能提供更好的服务
      <mu-flat-button slot="actions" primary @click="goAddress" label="去选择"/>
      <mu-flat-button slot="actions" primary @click="close" label="暂不选择"/>
    </mu-dialog>
  </div>
</template>

<script>
import siteconfig from '../util/siteconfigCache'
import map from '../util/map'
export default {
  data() {
    return {
      animate: false,
      loaded: true,
      siteInfo: {},
      templeteData:{},
      noticeList:[],
      noticeMarginTop : 0,
      userData : {},
      isLogin:false,
      mid:this.$route.query.mid,
      salesmanShopName:'',
      addressCache :'',
      dialog: false,
      bannerHeight:0,
      gonggaoTop:0,
      bottomNavList:[],      
      nowYear: new Date().getFullYear(),
      shareTitle:'旭日购商城',
      shareDesc:'',
      shareLinkUrl:'',
      shareImgUrl:'https://imgserver.xurigo.com/upload/images/product/2021/07/26/09441530f0733e-2841-4320-acb7-7266c3a3f5d1.png',
    };
  },
  props:{    
    guid:'',
    configData:{}
  },
  computed:{
  
  },
  mounted() {
    this.getBottomList()
    this.getSiteInfo()
    this.gonggaoTop = this.$el.offsetWidth*0.2*0.6*2+20+36+12+24+6
    var countyCache = window.localStorage.ProductDetailDeliveryAreaCache
    if(countyCache){
      this.addressCache = countyCache
    }else{
      var cityCache = window.localStorage.ProductDetailDeliveryCityCache
      if(cityCache){
        this.addressCache = cityCache
      }
    }
    if(!this.addressCache){
      this.dialog = true
    }else{
      if(this.addressCache.length>3){
        this.addressCache = this.addressCache.substr(0,3)+"..."
      }
    }
    var accesstoken = this.$route.query.accesstoken
    if(accesstoken){
      this.$store.dispatch('SetUser', accesstoken)
    }
    var openId = this.$route.query.openId
    if(openId){
      this.$store.dispatch('SETWeChat', openId)
    }
    var sessionId = this.$store.state.user.SessionId
    if(sessionId){
      this.isLogin = true
    }
    var redirectUrl = this.$route.query.redirectUrl
    if(redirectUrl){
      this.$router.push(redirectUrl)
    }
   
    this.getSalesmanShopInfo()

    this.getIndexTempleteConfig()
    this.getTopNoticeList()
    
    // if(this.isLogin){
    //   this.getUserInfo()
    // }
    if(this.isLogin){
      this.getUserInfo()
    } else {
      var ths = this;
      this.$postBase(
        this.MOBILE_URL + "/Oauth2/WeChat/wechat.ashx"
        ).then(function(res) {
        if(!res.IsSuccess){
            //ths.$refs.XRtoast.failed(res.Msg, true)
        }else{
            wx.config({
                debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
                appId: res.Data.AppId, // 必填，公众号的唯一标识
                timestamp: res.Data.TimeStamp, // 必填，生成签名的时间戳
                nonceStr: res.Data.NonceStr, // 必填，生成签名的随机串
                signature: res.Data.Sign, // 必填，签名，见附录1
                jsApiList: ['onMenuShareTimeline', 'onMenuShareAppMessage', 'onMenuShareQQ', 'onMenuShareQZone'] // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
            });
            ths.shareLinkUrl = "https://m.whmulanhui.com/H5Recommend.aspx?source_username=MLH7613327";
            wx.ready(function () {              
                wx.onMenuShareTimeline({
                    title: ths.shareTitle, // 分享标题
                    link: ths.shareLinkUrl, // 分享链接
                    imgUrl: ths.shareImgUrl, // 分享图标
                    success: function () {
                    },
                    cancel: function () {
                        // 用户取消分享后执行的回调函数
                    }
                });

                wx.onMenuShareQQ({
                    title: ths.shareTitle, // 分享标题
                    desc: ths.shareDesc, // 分享描述
                    link: ths.shareLinkUrl, // 分享链接
                    imgUrl: ths.shareImgUrl, // 分享图标
                    success: function () {
                    },
                    cancel: function () {
                        // 用户取消分享后执行的回调函数
                    }
                });

                wx.onMenuShareAppMessage({
                    title: ths.shareTitle, // 分享标题
                    desc: ths.shareDesc, // 分享描述
                    link: ths.shareLinkUrl, // 分享链接
                    imgUrl: ths.shareImgUrl, // 分享图标
                    success: function () {
                    },
                    cancel: function () {
                        // 用户取消分享后执行的回调函数
                    }
                });
                wx.onMenuShareQZone({
                    title: ths.shareTitle, // 分享标题
                    desc: ths.shareDesc, // 分享描述
                    link: ths.shareLinkUrl, // 分享链接
                    imgUrl: ths.shareImgUrl, // 分享图标
                    success: function () {
                        // 用户确认分享后执行的回调函数
                    },
                    cancel: function () {
                        // 用户取消分享后执行的回调函数
                    }
                });
            });
        }
      });
    }
  },
  created: function () {
    setInterval(this.calcNoticeMarginTop, 5000)
    },
  methods: {
    // getUserInfo(){      
    //   const ths = this;
    //   this.$post("/Shop/UserServer/GetUserInfo")
    //   .then(function(res) {
    //   })
    //   .catch(function(err) {
    //     console.log(err);
    //   });
    // },
    getUserInfo(){      
       const ths = this;
       this.$post("/Shop/UserServer/GetUserInfo")
       .then(function(res) {
         if (!res.Data.IsTestPhone){
            ths.$router.push('/usercenter/mobileBind')
            return;
         }
         ths.initShare(res.Data.user_name);
       })
       .catch(function(err) {
         console.log(err);
       });
    },
    initShare(username){
      var ths = this;
      this.$postBase(
        this.MOBILE_URL + "/Oauth2/WeChat/wechat.ashx"
        ).then(function(res) {
        if(!res.IsSuccess){
            //ths.$refs.XRtoast.failed(res.Msg, true)
        }else{
            wx.config({
                debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
                appId: res.Data.AppId, // 必填，公众号的唯一标识
                timestamp: res.Data.TimeStamp, // 必填，生成签名的时间戳
                nonceStr: res.Data.NonceStr, // 必填，生成签名的随机串
                signature: res.Data.Sign, // 必填，签名，见附录1
                jsApiList: ['onMenuShareTimeline', 'onMenuShareAppMessage', 'onMenuShareQQ', 'onMenuShareQZone'] // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
            });
            ths.shareLinkUrl = "https://m.whmulanhui.com/H5Recommend.aspx?source_username=" + username;
            wx.ready(function () {              
                wx.onMenuShareTimeline({
                    title: ths.shareTitle, // 分享标题
                    link: ths.shareLinkUrl, // 分享链接
                    imgUrl: ths.shareImgUrl, // 分享图标
                    success: function () {
                    },
                    cancel: function () {
                        // 用户取消分享后执行的回调函数
                    }
                });

                wx.onMenuShareQQ({
                    title: ths.shareTitle, // 分享标题
                    desc: ths.shareDesc, // 分享描述
                    link: ths.shareLinkUrl, // 分享链接
                    imgUrl: ths.shareImgUrl, // 分享图标
                    success: function () {
                    },
                    cancel: function () {
                        // 用户取消分享后执行的回调函数
                    }
                });

                wx.onMenuShareAppMessage({
                    title: ths.shareTitle, // 分享标题
                    desc: ths.shareDesc, // 分享描述
                    link: ths.shareLinkUrl, // 分享链接
                    imgUrl: ths.shareImgUrl, // 分享图标
                    success: function () {
                    },
                    cancel: function () {
                        // 用户取消分享后执行的回调函数
                    }
                });
                wx.onMenuShareQZone({
                    title: ths.shareTitle, // 分享标题
                    desc: ths.shareDesc, // 分享描述
                    link: ths.shareLinkUrl, // 分享链接
                    imgUrl: ths.shareImgUrl, // 分享图标
                    success: function () {
                        // 用户确认分享后执行的回调函数
                    },
                    cancel: function () {
                        // 用户取消分享后执行的回调函数
                    }
                });
            });
        }
      });
    },
    touchEvent (){
      var scrollTop = this.$el.scrollTop
      this.$refs.ModuleYouPin[0].setScrollTop(scrollTop)
      var imgHeigth= document.querySelector('.wh_content').offsetHeight+50  
      var opacityValue=this.$el.scrollTop/imgHeigth
      var logoElem = document.querySelector('.xrglogo')
      if(opacityValue<=0.5){
        if(logoElem){
          logoElem.src= this.siteInfo.Logo
        }
      }
      else{
        if(logoElem){
          logoElem.src= this.siteInfo.LogoWhite
        }
      }   
      document.querySelector('.mu-appbar').style.background='rgba('+this.themeColor+',' +opacityValue+')'
      
    }, 
    selectArea(){
      this.$router.push('/address')
    },       
    getBottomList(){
      var ths = this;   
      ths.$post(
        "/Shop/AdServer/GetSiteBottomNavList",{clientType: this.ClientType, navType:2}
      ).then(function(res) {
        if(!res.IsSuccess){
        }else{          
          ths.bottomNavList = res.Data;
        }
      });
    },
    getSalesmanShopInfo:function(){
      var mid = ''
      if(!this.isLogin){
        if(this.mid){
          window.localStorage.XRSalesmanShopMId = this.mid
          mid = window.localStorage.XRSalesmanShopMId
        }else{
          mid = window.localStorage.XRSalesmanShopMId
        }        
        if(mid){
          const ths = this;
          this.$post("/Shop/SalesmanServer/UnauthGetShopSetting", {mid: mid})
          .then(function(res) {
            if (res.IsSuccess && res.Data.ShopName) {
              ths.salesmanShopName = res.Data.ShopName + '的微商城'
            }
          })
          .catch(function(err) {
            console.log(err);
          });
        }
      }else{        
        const ths = this;
        this.$post("/Shop/SalesmanServer/GetShopSetting")
        .then(function(res) {
          if(res.IsSuccess && res.Data.ShopName){
            ths.salesmanShopName = res.Data.ShopName + '的微商城'
          }
        })
        .catch(function(err) {
          console.log(err);
        });
      }
    },
    getSiteInfo: function() {
      const ths = this;
      this.$post("/Shop/SiteConfigServer/GetSiteConfig")
      .then(function(res) {
        if (res.IsSuccess) {
          ths.loaded = false;
          ths.siteInfo = res.Data;
          siteconfig.addSiteconfig(res.Data)
          ths.$refs.XRtoast.hide();
        }
      })
      .catch(function(err) {
        console.log(err);
      });
    },    
    getIndexTempleteConfig: function() {
      const ths = this;
      this.$post("/Shop/AdServer/ReadMobileIndexTempleteConfig")
      .then(function(res) {
        if (res.IsSuccess) {
          ths.loaded = false;
          ths.templeteData = res.Data
          ths.bannerHeight = ths.$refs.banner.offsetWidth*173/320-14
          ths.$refs.XRtoast.hide();
        }
      })
      .catch(function(err) {
        console.log(err);
      });
    },
    getTopNoticeList(){

      const ths = this;
      this.$post("/Shop/ArticleServer/GetInformationPage", {'pageIndex':1, 'pageSize':2 , 'clientType': 1})
      .then(function(res) {
        if (res.IsSuccess) {
          ths.loaded = false;
          
          ths.noticeList = res.Data.List
          ths.calcNoticeMarginTop()

          ths.$refs.XRtoast.hide();
        }
      })
      .catch(function(err) {
        console.log(err);
      });
    },
    getNoticeUrl(type,id){
      if(type == 1){
        return '/informationDetail?id='+id
      }else{
        return '/informationImgDetail?id='+id
      }
    },
    HTMLDecode(text) { 
      var temp = document.createElement("div"); 
      temp.innerHTML = text; 
      var output = temp.innerText || temp.textContent; 
      temp = null; 
      return output; 
    },
    calcNoticeMarginTop(){
        this.animate = true;
        setTimeout(()=>{
          this.noticeList.push(this.noticeList[0]);
          this.noticeList.shift();
          this.animate = false;
     },500)
    },

    toBeOnline:function(){
      this.$refs.XRtoast.load('拼命开发中...',true);
    },
    signin(){
      if(this.isLogin){
        this.$refs.XRsigin.show()
      }
      else{
        this.$refs.XRtoast.failed('请登录后再签到',true);
      }
    },
    goAddress(){
      this.$router.push("/address")
    },
    close(){
      var ths = this
      ths.dialog = false
      map.getLocation(function(){
        ths.addressCache = window.localStorage.ProductDetailDeliveryAreaCache
      })
    }
  },
  computed: {
    adListHeight: function() {
      var width = document.documentElement.clientWidth;
      var height = width / 1.77;
      return height;
    }
  }
};
</script>

<style>
.pageIndexPage .XR-index-head {
  position: fixed;
  z-index: 3000;
  background: rgba(0,0,0,0);
  box-shadow:unset;
}
.pageIndexPage .salesmanShopName{
  font-size: 12px;
}
.pageIndexPage .mu-appbar .right .mu-icon{
  color: #fff;
  font-size: 20px;
}
.pageIndexPage .mu-appbar .right>a>div{
  background: rgba(71, 74, 79, 0.3);
  border-radius: 50%;
}
.pageIndexPage .mu-appbar .right .mu-icon-button>div{
 background: rgba(71, 74, 79, 0.3);
 border-radius: 50%;
 
 width: 30px;
    height: 30px;
    text-align: center;
    padding-top: 3px;
}
.pageIndexPage .XR-index-head .mu-appbar-title {
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
}
.pageIndexPage .XR-index-head .mu-appbar-title  .mu-raised-button-wrapper{
  padding: 0;
}
.pageIndexPage .XR-index-head .mu-appbar-title img {
  height: 26px;
}
.pageIndexPage  .mu-appbar .left .mu-raised-button{
  height: 26px;
  font-size: 14px;
  background: rgba(71, 74, 79, 0.3);
  box-shadow: none;
  min-width: 50px;
  padding-left:10px; 
}
.pageIndexPage .XR-index-head .mu-raised-button-wrapper span{
  padding: 0;
}
.pageIndexPage .XR-index-head .mu-raised-button-wrapper .fa-angle-down{
  font-size: 12px;
  width: 12px;
  margin: 0;
}
.pageIndexPage .XR-index-head  .mu-icon-menu .fa-mymore{
  font-size: 16px;
  padding-top: 3px;
}

.pageIndexPage .bannerList {
  overflow: hidden;
  position: relative;
}
.pageIndexPage .bannerList .wh_content .wh_indicator{
  bottom: 20px;
}
.pageIndexPage .bannerList img {
  width: 100%;
}
.pageIndexPage .cicle_top{
  width: 155px;
  overflow: hidden;
  position: absolute;
  height: 50px;
  bottom: -30px;
  z-index: 10;
  left: calc(50% - 75px);
  left: -moz-calc(50% - 75px);
  left: -webkit-calc(50% - 75px);
  display: flex;
  justify-content: center;
}
.pageIndexPage .cicle{
  width: 155px;
  padding: 0 20px;
  border-radius: 6px;
  background: url('/static/index/storeNameBg.png') no-repeat;
  background-size: 100%;
  position: absolute;
  font-weight: 600;
  font-size: 12px;
  height: 50px;
  line-height: 23px;
  text-align: center;
  overflow: hidden;
}
.pageIndexPage .nav {
  margin: 0 0 6px;
  position: absolute;
  z-index: 20;
}
.pageIndexPage .nav ul {
  width: 100%;
  overflow: hidden;
  background: white;
  padding: 12px 0;
}
.pageIndexPage .nav li {
  float: left;
  width: 20%;
  background: white;
  padding: 3px 0;
  list-style: none;
}
.pageIndexPage .nav li .link-btn {
  display: block;
  overflow: hidden;
}
.pageIndexPage .nav li .link-btn img {
  width: 60%;
  display: block;
  margin: 5px auto;
}
.pageIndexPage .nav li .link-btn i.icon-jkklgo {
  color: #666;
  font-size: 2rem;
  line-height: 1.2;
  text-align: center;
  display: block;
}
.pageIndexPage .nav li .link-btn b {
  text-align: center;
  font-size: 12px;
  background: #fff;
  color: #666;
  display: block;
  white-space: nowrap;
  font-weight: 400;
}

.pageIndexPage #focus {
  background: white;
}
.pageIndexPage #focus img {
  display: block;
  width: 100%;
}

/*
** 头条样式
*/
.pageIndexPage #gonggao
{
    width:100%;
    color:#000;
    padding:10px 0;
    background:white;
    position:relative;
    overflow:hidden;
    margin:6px 0;
    display: flex;
    align-items: center;
    margin-top: 195px;
    background: url('/static/index/top2.png');
    background-size: 100% 100%;
}
.pageIndexPage #gonggao .gg-title{
   float:left;
   width:17%; margin:0 2%;position: relative;height: 44px;transform-style: preserve-3d;
   /*transform: rotateY(0);*/
   /*animation:gonggao 3s infinite;*/
   /*-webkit-animation:gonggao 3s infinite;*/ /* Safari and Chrome */
}

@keyframes gonggao
{
	from { transform: rotateY(0);}
	to { transform: rotateY(180deg);}
}

@-webkit-keyframes gonggao /* Safari and Chrome */
{
	from { transform: rotateY(0);}
	to {transform: rotateY(180deg);}
}
.pageIndexPage #gonggao .gg-title img { width: 100%; display:block;position: absolute;top: 0;left: 0;height: 100%; backface-visibility: hidden;}
.pageIndexPage #gonggao .gg-list {  width:72%; height:46px; overflow:hidden;  padding-left:3%; border-left:1px solid #eee; }
.pageIndexPage #gonggao .gg-list ul { height:92px; padding-left:36px;}
.pageIndexPage #gonggao .gg-list img { float:left; margin-top:15px;}
.pageIndexPage #gonggao .gg-list li { height:40px; padding:3px 0; list-style:none;}
.pageIndexPage #gonggao .gg-list li p.title { height:24px; line-height:24px; font-size:14px; color:#fff; text-overflow:ellipsis; overflow:hidden;white-space:nowrap;}
.pageIndexPage #gonggao .gg-list p.content { height:16px; line-height:16px; font-size:12px; text-overflow:ellipsis; overflow:hidden;white-space:nowrap;color: orange;}
.pageIndexPage #gonggao .gg-list p.MsoNormal { height:16px; line-height:16px; font-size:12px; text-overflow:ellipsis; overflow:hidden;white-space:nowrap;}
/*
** 头条样式.end
*/

.pageIndexPage .ad1 .btn-list {
  position: absolute;
  top: 50%;
  left: 15%;
  z-index: 999;
  display: none;
}
.pageIndexPage .area-market-ad.ad1 {
  width: 100%;
  background: white;
}

.pageIndexPage .area-market-ad.ad1 .head-title {
  text-align: center;
  padding: 18px 0 18px;
  background: #efefef;
}

.pageIndexPage .area-market-ad.ad1 .head-title .icon {
  vertical-align: middle;
  height: 40px;
}

.pageIndexPage .area-market-ad.ad1 .head-title .text {
  vertical-align: middle;
  font-size: 18px;
  border-left: 2px solid #333;
  border-right: 2px solid #333;
  padding: 0 10px;
  color: Black;
}

.pageIndexPage .area-market-ad.ad1 .head-title .desc {
  vertical-align: sub;
  font-size: 12px;
  border-left: 1px solid red;
  padding-left: 8px;
  margin-left: 5px;
  color: #999;
}
.pageIndexPage .area-market-ad.ad1 .ad-list {
  width: 100%;
  overflow: hidden;
}
.pageIndexPage .area-market-ad.ad1 .ad-list .ad-item {
  position: relative;
  overflow: hidden;
}
.pageIndexPage .area-market-ad.ad1 .ad-list .left {
  width: 50%;
  height: 100%;
  float: left;
}
.pageIndexPage .area-market-ad.ad1 .ad-list .right {
  width: 50%;
  height: 100%;
  float: right;
}
.pageIndexPage .marquee_top {
	transition: all 1s;
	margin-top: -50px
}
.pageIndexPage .area-market-ad.ad1 .ad-list .item2 .text-info .desc {
  line-height: 16px;
  font-size: 12px;
  text-align: center;
}


.pageIndexPage .yingxiao .title {
  overflow: hidden;
  padding: 14px 0;
  text-align: center;
}
.pageIndexPage .yingxiao .title .center {
  overflow: hidden;
  margin: 0 auto;
  width: 112px;
}
.pageIndexPage .yingxiao .title .todayMiddle img,.pageIndexPage .yingxiao .title .yingxiaoMiddle img {
  width: 24px;
  float: left;
}
.pageIndexPage .yingxiao .title .big {
  font-size: 18px;
  line-height: 24px;
  margin: 0 5px 2px;
}
.pageIndexPage .yingxiao .title .small {
  font-size: 12px;
  color: #6e675d;
  text-align: center;
  line-height: 12px;
  padding: 0 5px;
  margin: 10px 0;
  border-left: 1px solid #000;
  border-right: 1px solid #000;
}

.pageIndexPage .yingxiao.youpin .pro-list {
  overflow: hidden;
}
.pageIndexPage .yingxiao.youpin .pro-list .item {
  float: left;
  width: 49%;
  margin-bottom: 2%;
  background: white;
}
.pageIndexPage .yingxiao.youpin .pro-list .item.marginright {
  margin-right: 2%;
}
.pageIndexPage .yingxiao.youpin .pro-list .item img {
  width: 100%;
}
.pageIndexPage .yingxiao.youpin .pro-list .item .price {
  overflow: hidden;
  padding: 0 2%;
}
.pageIndexPage .yingxiao.youpin .pro-list .item .price p {
  float: left;
  color: Red;
}
.pageIndexPage .yingxiao.youpin .pro-list .item .price .money {
  font-size: 16px;
  color: red;
  margin-right: 10px;
}
.pageIndexPage .yingxiao.youpin .pro-list .item .price .del {
  font-size: 12px;
  text-decoration: line-through;
  float: left;
  color: #7b7b7b;
  height: 24px;
  line-height: 24px;
}
.pageIndexPage .yingxiao.youpin .pro-list .item .name {
  color: Black;
  margin: 2% 2% 8%;
  line-height: 14px;
  height: 40px;
  overflow: hidden;
  line-height: 20px;
}

.pageIndexPage .bottom-line {
  position: relative;
  overflow: hidden;
  margin: 30px 30px 0;
  align-items: center;
  display: flex;
}
.pageIndexPage .bottom-line .bottomImg {
  width: 24%;
  padding: 0 3%;
}
.pageIndexPage .bottom-line .lineOne {
  width: 35%;
  height: 1px;
  background: #dedede;
  z-index: 1;
  float: left;
  margin-top: 15px;
}
.pageIndexPage .bottom-line .lineTwo {
  width: 35%;
  height: 1px;
  background: #dedede;
  z-index: 1;
  float: right;
  margin-top: 15px;
}
.pageIndexPage .fa-xisearch{
  font-size: 22px;
  }
.pageIndexPage .buynow {width:100%; position:relative;}
.pageIndexPage .buynow .bg { width:100%; display:block;}
.pageIndexPage .buynow .countdown { position:absolute; top:15px; width:50%; left:55%;}
.pageIndexPage .buynow .countdown span { float:left; height:23px; line-height:23px; color:Black;}
.pageIndexPage .buynow .countdown .desc { margin-right:5px;}
.pageIndexPage .buynow .countdown .font { font-size:12px; width:14px; text-align:center;}
.pageIndexPage .buynow .countdown .time { font-size:18px; width:14px; height:23px; text-align:center; background:url(/static/active/countdown.png) no-repeat; color:white;}
    
.pageIndexPage .buynow .product-list { width:95.6%; position:absolute; top:63%; bottom:0; overflow:hidden; left:2.2%;}
    
.pageIndexPage .buynow .product-list .img-box { width:29.1%; height:90%; float:left;}
.pageIndexPage .buynow .product-list .img-box.wait { float:right;position:relative;}
.pageIndexPage .buynow .product-list .img-box.wait .zz { position:absolute; top:5%; bottom:5%; right:5%; background: rgba(0,0,0,.4); z-index:0; width:90%;} 
.pageIndexPage .buynow .product-list .img-box.wait .zz .box { border:1px solid white; margin:5%; height:90%;} 
.pageIndexPage .buynow .product-list .img-box.wait .zz .box .sd-bg { width:40%; display:block; margin:20% auto 0;}
.pageIndexPage .buynow .product-list .img-box.wait .zz .box .desc { font-size:12px; color:White; text-align:center;}
.pageIndexPage .buynow .product-list .img-box .padding { width:90%; height:90%; padding:5%;}
.pageIndexPage .buynow .product-list .img-box .bn-img {height:100%;width: 100%; display:block;}               
            
.pageIndexPage .buynow .product-list .info-box { width:41.8%; float:left; height:90%; overflow:hidden; position:relative;}
.pageIndexPage .buynow .product-list .info-box .name { width:100%; line-height:14px; height:28px; font-size:12px; color:Black;overflow: hidden; margin-top:5px;}
.pageIndexPage .buynow .product-list .info-box .price { color:Black; padding:5px 0; overflow:hidden;}
.pageIndexPage .buynow .product-list .info-box .price span { float:left; height:16px;}
.pageIndexPage .buynow .product-list .info-box .price span.buynow-price { font-size:14px; color:Red; line-height:20px;}
.pageIndexPage .buynow .product-list .info-box .price span.buynow-price-desc { font-size:12px; color:Red; line-height:20px;}
.pageIndexPage .buynow .product-list .info-box .price span.sku-price { font-size:12px; line-height:20px; text-decoration:line-through; color:#999;}
.pageIndexPage .buynow .product-list .info-box .btn { width:98%; overflow:hidden; position:absolute; padding:5px 1%;}
.pageIndexPage .buynow .product-list .info-box .btn .stock { float:left; font-size:12px; color:Black; line-height:18px; height:18px; color:#666;}
.pageIndexPage .buynow .product-list .info-box .btn .btn-box { float:right;}
.pageIndexPage .buynow .product-list .info-box .btn .btn-box .btn-bg { display:block; float:right; }
.pageIndexPage .buynow .product-list .info-box .btn .btn-box .botton { clear:both; font-size:12px; line-height:18px; height:18px; color:white; border-radius:25px; padding:0 5px; background:#999; margin-right:5px;}
.pageIndexPage .buynow .product-list .info-box .btn .btn-box .botton.red {color:White; background:red;}


.pageIndexPage .bottom-nav {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 9999;
}


.pageIndexPage  .foot_inf{
  padding:18px;
}
.pageIndexPage  .foot_inf p,
.pageIndexPage  .foot_inf h3,
.pageIndexPage  .foot_inf a{
  text-align: center;
  line-height: 1.6em;
}
.pageIndexPage  .foot_inf p a{
  font-size: 1rem;
  color:#4d4d4d;
}
.pageIndexPage  .foot_inf p a.on{
  color:#e40011;
}
.pageIndexPage  .foot_inf p i{
  padding:0 20px;
}
.pageIndexPage  .foot_inf h3 i{
  padding:0 15px;
}
.pageIndexPage  .foot_inf h3{
  font-size:12px;
  font-weight: normal;
  color:#aeaeae;
}
.pageIndexPage  .foot_inf p{
  font-size:12px;
}
.pageIndexPage  .foot_inf p b{
  padding:0 7px;
}

.pageIndexPage .foot_inf p a.beianLink{
  font-size:12px;
}
.pageIndexPage .foot_inf p a.beianLink:hover{
  color:red;
  text-decoration: underline;
}
</style>



// WEBPACK FOOTER //
// src/pages/index.vue